<div
    class="lobby-bg"
    *ngIf="showImage"
    [ngClass]="fullTakeoverBgToggleType | lowercase"
    [style.background-color]="fullTakeOverLobbyBackgroundColor"
    [style.background-image]="'url(' + lobbyBackgroundImg + ')'"></div>
<div *ngIf="currentCategoryInfo?.categoryInfo?.sitecoreData?.coinShower?.length > 0 && enableCoinShower">
    <cc-coineconomy-component></cc-coineconomy-component>
</div>
